module.exports = __webpack_public_path__ + "img/没有团队.df974187.svg";